import lowerCase from 'lodash/lowerCase';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { SearchCategoryTypes } from '@yme/utils/bloomreach';
import { getDateWithCapitalLetterMonth, prepareDateRangeText } from '@yme/utils/common';
import { regExpSpecialCharacters } from '@yme/utils/regEx';
import { HIGHLIGHT_TEXT_ID, WORDS_BEFORE_MATCHING } from './constants';
export function modifyText(fullText = '', textToHighlight, symbolsInLine, countLineVisible) {
    const splittedText = fullText.split(' ');
    const splittedTextToHighlight = textToHighlight.split(' ');
    const firstWordToHighlightLowerCase = lowerCase(splittedTextToHighlight[0]);
    const indexTextToHighlight = splittedText.findIndex((word, i, arr) => {
        if (splittedTextToHighlight.length === 1) {
            return lowerCase(word).includes(firstWordToHighlightLowerCase);
        }
        if (lowerCase(word).includes(firstWordToHighlightLowerCase)) {
            return (lowerCase(textToHighlight) ===
                lowerCase(arr.slice(i, i + splittedTextToHighlight.length).join(' ')));
        }
        return false;
    });
    if (indexTextToHighlight > WORDS_BEFORE_MATCHING &&
        fullText.length > symbolsInLine * countLineVisible) {
        return `...${splittedText.slice(indexTextToHighlight - WORDS_BEFORE_MATCHING).join(' ')}`;
    }
    return fullText;
}
export function highlightText(text = '', textToHighlight) {
    if (!textToHighlight) {
        return text;
    }
    try {
        // escape special characters in textToHighlight
        const textToHighlightModified = textToHighlight.replace(regExpSpecialCharacters, '\\$&');
        const regex = new RegExp(`(${textToHighlightModified})`, 'gi');
        return text.replace(regex, `<span style="color:${colorBrandYamahaRed}" id="${HIGHLIGHT_TEXT_ID}">$1</span>`);
    }
    catch (error) {
        return text;
    }
}
export function getCountLineVisible(isMobile, isTablet) {
    if (isMobile) {
        return 3;
    }
    if (isTablet) {
        return 2;
    }
    return 1;
}
export function countSymbolsInLine(text, width, font, fontSize) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
        return 0;
    }
    context.font = `${fontSize} ${font}`;
    let totalWidth = 0;
    let symbolsCount = 0;
    for (const char of text) {
        totalWidth += context.measureText(char).width;
        if (totalWidth > width) {
            break;
        }
        symbolsCount++;
    }
    return symbolsCount;
}
export function getFormattedDate(date, language) {
    const formatted = new Intl.DateTimeFormat(language, {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
    });
    const newsDate = new Date(date);
    return getDateWithCapitalLetterMonth(formatted, newsDate);
}
export function getCaption(date, dateTo, category, language) {
    if (category === SearchCategoryTypes.NEWS) {
        return getFormattedDate(date, language);
    }
    if (category === SearchCategoryTypes.EVENTS) {
        return prepareDateRangeText({
            dateFrom: date,
            dateTo,
            lang: language,
            hasTime: false,
        });
    }
    return '';
}
